import { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaPencil } from "react-icons/fa6";
import { MdOutlineDelete } from "react-icons/md";
import AddRuleModal from "./addruleModal";
import AddRule from "./addRule";

const Rules = ({ territoryList, showTreeNode, updateRule }) => {
    const groupByParentId = (territories) => {
        const obj = {};
        territories?.forEach(territory => {
            const key = territory.parent_territory?.id || "null";
            if (!obj[key]) obj[key] = [];
            obj[key].push(territory);
        });
        return obj;
    };

    let result = groupByParentId(territoryList);

    const [showViewRule, setShowViewRule] = useState(false)
    const [viewRuleIndex, setViewRuleIndex] = useState(null);

    const [showAddRule, setShowAddRule] = useState(false)
    let [selectedRowToAddRule, setSelectedRowToAddRule] = useState(null)

    const handleShowViewRule = () => {
        setShowViewRule(!showViewRule)
        setSelectedRowToAddRule(null)
    }

    const handleHideAddRule = () => {
        setShowAddRule(false)
    }

    const handleRule = (rule, data) => {
        updateRule(rule, data)
    }

    const getCriteria = (length) => {
        if (length === 0) return '';
        if (length === 1) return '1';
        if (length === 2) return '(1 and 2)';

        const previous = getCriteria(length - 1);
        return `(${previous} and ${length})`;
    };

    const TreeNode = (parentId, isInitial = false) => {
        let data = result[parentId] || [];
        return (
            <ul className={isInitial ? "tree mt-3" : "nested-list"}>
                {data?.map(child => (
                    <>
                        <li className={isInitial ? "parent" : "nested-item"} key={child._id}>
                            <div className="d-inline-block ps-4 role-name-box cursor-pointer">
                                {child.territory_name}
                                {!isInitial &&
                                    <>
                                        {child?.account_rule?.length === 0 &&
                                            <span className="add-territory-rule"
                                                onClick={() => { setSelectedRowToAddRule(child); setShowAddRule(true) }}>
                                                Add Rule</span>
                                        }
                                        {child?.account_rule?.length > 0 &&
                                            <>
                                                {child._id === viewRuleIndex ?
                                                    <span className="add-territory-rule"
                                                        onClick={() => { handleShowViewRule(); setViewRuleIndex(child._id) }}>
                                                        {showViewRule ? 'Hide Rule' : 'View Rule'}
                                                    </span> :
                                                    <span className="add-territory-rule"
                                                        onClick={() => { setShowViewRule(true); setViewRuleIndex(child._id) }}>
                                                        View Rule
                                                    </span>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div>
                            {result[child._id] && (
                                <details open={showTreeNode} className="details">
                                    <summary></summary>
                                    {TreeNode(child._id)}
                                </details>
                            )}
                        </li>
                        {(child._id === viewRuleIndex && showViewRule) &&
                            <li className="nested-item view-rule" key={child._id}>
                                <div class="d-inline-block card mb-2">
                                    <h6>Territory Rules</h6>
                                    {child?.account_rule?.map((obj, i) => (
                                        <div className={i > 0 && 'mt-2'}>
                                            <span>{i + 1}. </span>
                                            <span>{obj?.field?.split('#')?.[1]}</span>
                                            <span style={{ color: '#20b8a8' }} className="ms-1 me-1">{obj?.condition?.split('#')?.[1]}</span>
                                            <span>{obj?.value}</span>
                                        </div>
                                    ))}
                                    {child?.account_rule?.length > 1 &&
                                        <div className="mt-2">
                                            <div className="col-auto d-flex align-items-center">
                                                <span className="fw-medium">Criteria Pattern</span>
                                                <i className="bi bi-question-circle text-primary ms-2" style={{ fontSize: '16px' }}></i>
                                            </div>
                                            <div className="col mt-2">
                                                <span className="text-muted">{getCriteria(child?.account_rule?.length)}</span>
                                                {/* <button className="btn btn-link ms-2 text-primary p-0">Edit Pattern</button> */}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </li>
                        }
                    </>
                ))}
            </ul>
        );
    };

    return (
        <>
            <div className="territory-tree">{TreeNode("null", true)}</div>
            {showAddRule &&
                // <AddRule isOpen={showAddRule} onClose={handleHideAddRule} handleRule={handleRule} isCreateRule={true} territoryData={selectedRowToAddRule} />
                <AddRuleModal isOpen={showAddRule} onClose={handleHideAddRule} handleRule={handleRule} isCreateRule={true} territoryData={selectedRowToAddRule} />
            }
        </>
    )
}
export default Rules;